import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Share2 } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const siteUrl = 'https://borninyu.com';
  const shareText = 'Born in YU - Bureaucratic Chic Yugoslav Nostalgia Apparel';

  const handleShare = (platform: string) => {
    const encodedUrl = encodeURIComponent(siteUrl);
    const encodedText = encodeURIComponent(shareText);

    const shareUrls: { [key: string]: string } = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      reddit: `https://reddit.com/submit?url=${encodedUrl}&title=${encodedText}`,
      email: `mailto:?subject=${encodedText}&body=${encodedText}%20${encodedUrl}`,
    };

    if (shareUrls[platform]) {
      window.open(shareUrls[platform], '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer className="bg-black text-white p-6 md:p-12">
      <div className="flex flex-col md:flex-row justify-between gap-12 mb-12">
        <div className="max-w-xs">
          <div className="text-2xl font-black mb-4 uppercase tracking-tighter">
            {t('header.title')}
          </div>
          <p className="text-[10px] uppercase font-bold text-gray-500 mb-6">
            {t('footer.tagline')}
          </p>
          <div>
            <p className="text-[10px] uppercase font-bold text-gray-400 mb-2 flex items-center gap-2">
              <Share2 size={12} />
              Share
            </p>
            <div className="flex gap-2 flex-wrap">
              <button
                onClick={() => handleShare('facebook')}
                className="px-3 py-1 border border-white text-[10px] font-black uppercase hover:bg-white hover:text-black transition-colors"
                title="Share on Facebook"
              >
                Facebook
              </button>
              <button
                onClick={() => handleShare('twitter')}
                className="px-3 py-1 border border-white text-[10px] font-black uppercase hover:bg-white hover:text-black transition-colors"
                title="Share on Twitter/X"
              >
                Twitter
              </button>
              <button
                onClick={() => handleShare('linkedin')}
                className="px-3 py-1 border border-white text-[10px] font-black uppercase hover:bg-white hover:text-black transition-colors"
                title="Share on LinkedIn"
              >
                LinkedIn
              </button>
              <button
                onClick={() => handleShare('reddit')}
                className="px-3 py-1 border border-white text-[10px] font-black uppercase hover:bg-white hover:text-black transition-colors"
                title="Share on Reddit"
              >
                Reddit
              </button>
              <button
                onClick={() => handleShare('email')}
                className="px-3 py-1 border border-white text-[10px] font-black uppercase hover:bg-white hover:text-black transition-colors"
                title="Share via Email"
              >
                Email
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          <div>
            <h4 className="text-[10px] font-black text-gray-500 uppercase mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="text-xs font-bold uppercase space-y-2">
              <li>
                <Link to="/about" className="hover:text-[#C41E3A]">
                  {t('footer.links.about')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-[#C41E3A]">
                  {t('footer.links.products')}
                </Link>
              </li>
              <li>
                <Link to="/archive" className="hover:text-[#C41E3A]">
                  {t('footer.links.archive')}
                </Link>
              </li>
              <li>
                <Link to="/manifesto" className="hover:text-[#C41E3A]">
                  {t('footer.links.manifesto')}
                </Link>
              </li>
              <li>
                <Link to="/dossier" className="hover:text-[#C41E3A]">
                  {t('footer.links.dossier')}
                </Link>
              </li>
              <li>
                <Link to="/spomenik-maps" className="hover:text-[#C41E3A]">
                  {t('footer.links.spomenikMaps')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#C41E3A]">
                  {t('footer.links.contact')}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-[10px] font-black text-gray-500 uppercase mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="text-xs font-bold uppercase space-y-2">
              <li>
                <Link to="/shipping" className="hover:text-[#C41E3A]">
                  {t('footer.links.shipping')}
                </Link>
              </li>
              <li>
                <Link to="/returns" className="hover:text-[#C41E3A]">
                  {t('footer.links.returns')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-[#C41E3A]">
                  {t('footer.links.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-[#C41E3A]">
                  {t('footer.links.terms')}
                </Link>
              </li>
            </ul>
          </div>
          {/* Newsletter section - hidden for now */}
          {/* <div className="col-span-2 md:col-span-1">
            <h4 className="text-[10px] font-black text-gray-500 uppercase mb-4">
              {t('footer.newsletter')}
            </h4>
            <p className="text-[10px] uppercase text-gray-500 mb-2">{t('footer.newsletterText')}</p>
            <div className="border border-white p-2 flex">
              <input
                type="email"
                placeholder={t('footer.emailPlaceholder').toUpperCase()}
                className="bg-transparent border-none outline-none text-[10px] w-full placeholder:text-gray-700"
              />
              <button className="text-[10px] font-black">
                {t('footer.subscribe').split(' ')[0]}
              </button>
            </div>
          </div> */}
        </div>
      </div>

      <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-bold uppercase text-gray-600">
        <div>{t('footer.copyright')}</div>
        <div className="flex gap-4">
          <Link to="/terms" className="hover:text-[#C41E3A]">
            {t('footer.links.terms')}
          </Link>
          <Link to="/privacy" className="hover:text-[#C41E3A]">
            {t('footer.links.privacy')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
